export default {
  filters: {
    managers: {
      placeholder: 'Myyntipäälliköt',
    },
  },
  metrics: {
    collected_commission: 'Provisio yhteensä',
  },
  fields: {
    manager: 'Päällikkö',
    area: 'Sijainti',
    total_amount: 'Ansaintaa',
    companies_live: 'Live',
    restaurant: 'Ravintola',
    live_from: 'Live alkaen',
    plan_amount: 'Suunnitelman summa',
    prepayment_bonus_amount: 'Ennakkomaksubonus',
    lead_source_bonus_amount: 'Liidilähdebonus',
    google_business_bonus_amount: 'Google-yritystilin liittämisbonus',
    promo_code_bonus_amount: 'Master-alennuskoodibonus',
    smart_pricing_bonus_amount: 'Älykkään hinnoittelun bonus',
    mobile_app_bonus_amount: 'Mobiilisovellusbonus',
    sales_goal_bonus_amount: 'Myyntitavoitebonus',
  },
  buttons: {
    export: 'Vie',
  },
  toasts: {
    failed_to_load_data: 'Tietojen lataaminen epäonnistui',
  },
};
